// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKButton from 'components/MKButton';
import MKTypography from 'components/MKTypography';

function GalleryHeader() {
  return (
    <MKBox mb={5} bgColor='warning'>
      <MKBox py={10} display='flex' alignItems='center' minHeight='100%'>
        <Container>
          <Grid
            container
            item
            xs={12}
            md={7}
            lg={6}
            flexDirection='column'
            justifyContent='center'
          >
            <MKTypography
              variant='h1'
              textGradient
              mb={3}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down('md')]: {
                  fontSize: size['3xl'],
                },
              })}
            >
              Photo Gallery
            </MKTypography>
            <MKTypography variant='body1' color='light' pr={6} mr={6}>
              Official images from all our events grouped and catalogued for you
            </MKTypography>
            <Stack direction='row' spacing={1} mt={3}>
              <MKButton component={Link} to='/contact-us' color='white'>
                Become a member
              </MKButton>
              <MKButton
                component={Link}
                to='/events'
                variant='text'
                color='white'
              >
                Go to Events
              </MKButton>
            </Stack>
          </Grid>
        </Container>
      </MKBox>
    </MKBox>
  );
}

export default GalleryHeader;
